import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchPromise = <T>(): ((props: T) => Promise<any>) => {
  const dispatch = useDispatch();
  return useCallback((props) => {
    return new Promise((resolve, reject) => {
      dispatch({ ...props, resolve, reject });
    });
  }, [dispatch]);
};